import {
  Box,
  BoxProps,
  LinearProgress,
  LinearProgressProps,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

const LinearProgressWithLabel: React.FC<
  LinearProgressProps & {
    value: number;
  }
> = ({ value, ...props }) => {
  const percent = Math.round(value);
  const text = `${percent}%`;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={value} {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

const ProgressIndicator: React.FC<
  BoxProps & {
    value?: number;
  }
> = ({ value = 0, ...props }) => {
  const [progress, setProgress] = useState(value);

  useEffect(() => {
    setProgress(value);
  }, [value]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 99 ? prevProgress : prevProgress + 1
      );
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box {...props}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
};

export default ProgressIndicator;
